<template>
  <el-carousel height="18vw" :autoplay="false">
      <el-carousel-item v-for="item in images" :key="item.basicId">
        <img :src="$store.state.baseUrl+item.basicThumbnails"/>
      </el-carousel-item>
    </el-carousel>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  data () {
    return {
      images: []
    }
  },
  computed: {
    ...mapGetters([
      'getCategoryAppid'
    ])
  },
  watch: {
    getCategoryAppid(id) {
      this.getSwiper(id)
    }
  },
  created(){
    this.getSwiper(this.$store.state.categoryAppid)
  },
  methods: {
    ...mapActions([
      'findPage'
    ]),
    getSwiper(id) {
      this.findPage({basicCategoryid: 255, page: 1,size: 100}).then(res=>{
        // console.log(res)
        this.images = []
        let temp = []
        res.data.dataList.map((item)=>{
          if((item.basicType == -1||item.basicType == id) && item.basicStatus == 1){
            temp.push(item)
          }
        })
        // console.log(temp)
        this.images = temp.sort((a, b) => {
          return a.basicSort-b.basicSort
        })
        // console.log(this.images)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
img {
  width: 100%;
  height: auto;
  cursor: pointer;
}

</style>
